






































import { Component, Mixins } from 'vue-property-decorator'
import { RouteConfig } from 'vue-router'
import { inject } from 'inversify-props'
import API from '@core/services/API'
import { namespace } from 'vuex-class'
import LoadingSpinner from '@core/components/LoadingSpinner.vue'
import AppSectionNavi from '@core/components/AppSectionNavi.vue'
import { ClientPolicyDto, PolicyIndividualDTO } from '@core/pages/new-business-register/api'
import { newBusinessRegisterRouter } from '@/router/new-business-register/NewBusinessRegisterRoutes'
import { isUndefined } from 'lodash/fp'
import ClientScreening from '@core/pages/new-business-register/components/ClientScreening.vue'
import BscMixin from './BscMixin'
import SubPolicyMixin from './SubPolicyMixin'
import { LineOfBusinessOptions } from '@master/model/options/LineOfBusinessOptions'
import { ComplianceResponseDto } from '@core/pages/compliance/api'

const clientPolicyStore = namespace('ClientPolicyStore')
const clientInfoStore = namespace('ClientInfoStore')
const complianceStore = namespace('ComplianceStore')

@Component({
  components: {
    LoadingSpinner,
    AppSectionNavi
  }
})
export default class NewBusinessRegister extends Mixins(BscMixin, SubPolicyMixin) {
  // Tag related scopes
  // To be separated into other classes, but for now, leave it here for the sake of time
  private isBscUnreviewed = true
  protected screenings: ClientScreening[] = []

  @inject()
  private $api: API

  @clientPolicyStore.State
  policy: ClientPolicyDto

  @clientPolicyStore.State
  private policyIndividuals: PolicyIndividualDTO[]

  @clientPolicyStore.State
  loading: boolean

  @clientPolicyStore.Action
  savePolicy

  @complianceStore.State
  private complianceResult: ComplianceResponseDto

  @clientPolicyStore.Action
  private fetchPolicyV2

  @clientPolicyStore.Action
  private fetchPolicyIndividuals

  @clientPolicyStore.Action
  private fetchAdviserDetails

  get isDisabled () {
    return this.$store.getters.currentUser.systemrole !== 'ops-staff'
  }

  get ownersName () {
    return this.policy ? this.policy.ownersName : ''
  }

  get ownersNric () {
    return this.policy ? this.policy.ownersNric : ''
  }

  get policyOid () {
    return this.$route.params.policyOid
  }

  get isNotRiderPage () {
    return !['Product Overview', 'Rider Details', 'ILP Details', 'Info Sheet', 'Product Entities / Individuals'].includes(this.$route.name)
  }

  get isOpstaff () {
    return this.$store.getters.currentUser.systemrole === 'ops-staff'
  }

  // REL_CLIENTS has hrcRoles and REL_POLICY_INDIVIDUAL data snapshot hrcRoles
  get hasHighRiskClient () {
    return this.complianceResult?.hrtIndividuals.length > 0
  }

  /**
   * @TODO: To make it into an interface such that we can utilize the src's route paths
   */
  get sections (): Array<RouteConfig> {
    const mainSections = newBusinessRegisterRouter.find(route => route.name === 'Policy').children

    // Utilizing the route configuration's meta to filter through what to display on the section
    // If the meta attribute in the route is undefined, it means available for all
    // @TODO: Although the section is not display in the navigation bar, the route is still available
    // to go to via manual entry, need to resolve this in the future
    const sectionsToDisplay = mainSections.map(mainSection => {
      if (isUndefined(mainSection.meta) || mainSection.meta?.policies.includes(this.policy.type)) {
        if (mainSection.children?.length > 0) {
          mainSection.children = mainSection.children.filter(subSection => isUndefined(subSection.meta) || subSection.meta?.policies.includes(this.policy.type))
        }

        return mainSection
      }

      return null
    }).filter(section => !!section)
    return sectionsToDisplay
  }

  openClientInfo () {
    const clientInfoUrl = this.$router.resolve({ path: `/client-info/${this.policy.clientOid}/profile` })
    window.open(clientInfoUrl.href, '_blank')
  }

  async getBscReviewStatus () {
    const response = await this.$api.bscRecords.listClientsReviewed({
      headers: JSON.stringify(['policy_number']),
      query: 'policy_number = ?',
      queryArgs: JSON.stringify([this.policy.policyNumber])
    })

    if (!response.data || response.data?.length === 0) {
      return
    }

    // a bsc record has been found
    this.isBscUnreviewed = false
  }

  // End of tag related scopes

  get productTypeBeautify () {
    const type = this.policy.type || ''
    return LineOfBusinessOptions.find(op => op.value === type)?.label || ''
  }

  get mainOwner () {
    return this.policyIndividuals?.find(individual => individual.isMainOwner)
  }

  get mainOwnerTag () {
    return this.mainOwner?.clientDataSnapshot?.clientId || ''
  }

  get mainOwnerName () {
    if (this.policyIndividuals.length === 0) {
      return ''
    }

    return `${this.mainOwner?.clientDataSnapshot.name}` || ''
  }

  async created () {
    await this.fetchPolicyV2(this.policyOid)
    if (!this.policy.oid) {
      window.location.href = '/live/policy-list'
    }
    await this.fetchAdviserDetails()
    await this.fetchPolicyIndividuals(this.policy.oid)

    await this.retrieveSubPolicies(this.policy.oid)
    const productOids = this.retrieveSubPoliciesProductOids()
    productOids.push(this.policy.productOid)

    if (this.isOpstaff) {
      this.getBscReviewStatus()
      await this.validateProductIsBscInscope(productOids)
    }
  }
}
